module.exports = __webpack_public_path__ + "img/Warrior-undead-f-70.623bda79.gif";